import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import EducationImg from "./EducationImg";
import { competitiveSites } from "../../portfolio";
import { certifications } from "../../portfolio";
import { degrees } from "../../portfolio";
import "./EducationComponent.css";
import { Fade } from "react-reveal";

class Education extends Component {
  render() {
    const theme = this.props.theme;
    const lang = this.props.lang;
    return (
      <div className="education-main">
        <Header lang={lang} theme={this.props.theme} />
        <div className="basic-education">
          <Fade bottom duration={2000} distance="40px">
            <div className="heading-div">
              <div className="heading-img-div">
                {/* <img
									src={require("../../assests/images/education.svg")}
									alt=""
								/> */}
                <EducationImg theme={theme} />
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.text }}>
                  {degrees.h1[lang]}
                </h1>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  {degrees.h3[lang]}
                </h3>
                <CompetitiveSites 
                  lang={lang} 
                  skill_hh={competitiveSites.skillAssessment_hh} 
                  skill_linkedin={competitiveSites.skillAssessment_linkedin} 
                  logos={competitiveSites.competitiveSites} 
                />
              </div>
            </div>
          </Fade>
          <Educations lang={lang} theme={this.props.theme} />
          {certifications.certifications.length > 0 ? (
            <Certifications lang={lang} theme={this.props.theme} />
          ) : null}
        </div>
        <Footer lang={lang} theme={this.props.theme} />
        <TopButton lang={lang} theme={this.props.theme} />
      </div>
    );
  }
}

export default Education;
